import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-delay-modal',
    templateUrl: './delay-modal.component.html',
    styleUrls: ['./delay-modal.component.scss'],
    standalone: false
})
export class DelayModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
